import { Link } from "react-router-dom";
import type { Video } from "@/utils/videoUtils";
import { formatCount } from "@/utils/format";

interface VideoCardProps {
  video: Video;
  showCategory?: boolean;
  compact?: boolean;
}

export default function VideoCard({ video, showCategory = false, compact = false }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block overflow-hidden rounded-lg bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative w-full overflow-hidden rounded-lg bg-background-200" style={{ aspectRatio: "16 / 9" }}>
        <img
          src={video.cover}
          alt={`${video.title} 短视频封面`}
          title={`${video.title} - 91抖音短视频`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <span className="absolute bottom-2 right-2 rounded-md bg-black/70 px-1.5 py-0.5 font-label text-[11px] text-white">
          {video.duration}
        </span>
        <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500/95 text-background-50">
            <i className="ri-play-fill text-xl"></i>
          </span>
        </span>
        {showCategory && (
          <span className="absolute left-2 top-2 rounded-md bg-secondary-950/70 px-2 py-0.5 text-[11px] text-background-50">
            {video.categoryName}
          </span>
        )}
      </div>
      <div className={compact ? "pt-2" : "pt-2.5"}>
        <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          {video.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-3-line"></i>
            {video.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-play-circle-line"></i>
            {formatCount(video.plays)}
          </span>
        </div>
      </div>
    </Link>
  );
}